<template>
  <div class="statistics">
    <div class="labelck">
      <b>案件标的统计</b>
    </div>
    <div class="moneyp">
      <div class="hd">
        <div class="li">
          <div class="tit">被告</div>
          <div class="p">{{ data.sum.debtor_count }}</div>
        </div>
        <div class="li">
          <div class="tit">案件总数</div>
          <div class="p">{{ data.sum.cause_count }}</div>
        </div>
        <div class="li">
          <div class="tit">结案数量</div>
          <div class="p">{{ data.sum.ja_cause_count }}</div>
        </div>
      </div>
      <div class="mid">
        <!-- <div class="li" v-for='(i,index) in feeList'>
          <div class="tp">
            <h4>{{i.tit}}</h4>
            <div class="span">被告:{{i.data.debtor_count || 0}}个</div>
            <div class="span">案件:{{i.data.cause_count || 0}}件</div>
          </div>
          <div class="p">{{index==5?'主张本金':'主张'}} ：{{i.data.zfee | douYuan}} 元</div>
          <div class="p" v-if='index<5'>{{index==2?'已退':'确认'}} ：{{(i.data.qfee || i.data.aleadyRefundFee) | douYuan}}{{index==5?'%':" 元"}}</div>
          <div class="p" v-if='index<5'>{{index==2?'未退':'案款'}} ：{{(i.data.payee || i.data.waitRefundFee) | douYuan}} 元</div>
          <div class="p" v-if='index==5'>比例 ：{{data.sum.cause_count==0 ?0:(((i.data.cause_count/data.sum.cause_count)*100).toFixed(2))}} %</div>
          <div class="p" v-if='i.type==1'>不退 ：{{i.data.notRefundFee | douYuan}} 元</div>
          <div class="p mess" v-if='i.type<0'>全部驳回数据取自经历一审、二审裁判<br>文书后仍没有确认债权本金录入的案件</div>
        </div> -->
        <div class="li">
          <div class="tp">
            <h4>本金</h4>
          </div>
          <div class="warp">
            <div class="p">主张：{{ data.capital.stand | douYuan }}元 </div>
            <div class="p">支持：{{ data.capital.support | douYuan }}元</div>
            <div class="p">确认中：{{ data.capital.checking | douYuan }}元</div>
            <div class="p">未支持：{{ data.capital.not_support | douYuan }}元</div>
          </div>
        </div>
        <div class="li">
          <div class="tp">
            <h4>律师费</h4>
          </div>
          <div class="warp">
            <div class="p">主张：{{ data.lawyer_fee.stand | douYuan }}元 </div>
            <div class="p">支持：{{ data.lawyer_fee.support | douYuan }}元</div>
            <div class="p">确认中：{{ data.lawyer_fee.checking | douYuan }}元</div>
            <div class="p">未支持：{{ data.lawyer_fee.not_support | douYuan }}元</div>
          </div>
        </div>
        <div class="li">
          <div class="tp">
            <h4>差旅费</h4>
          </div>
          <div class="warp">
            <div class="p">支持：{{ data.travel_fee.stand | douYuan }}元 </div>
          </div>
        </div>
      </div>
      <div class="loadspin"> <a-spin class="spin" tip="加载中" :spinning="load" /></div>
      <!-- <div class="rt">
        <lineChart type="2" id="linechart" :datas="lineData" v-if="lineData.load"></lineChart>
      </div> -->
    </div>
  </div>
</template>
<script>
import lineChart from '@/components/charts'
let Fee_list = [
  { tit: '本金', type: 8, data: {} },
  { tit: '律师费', type: 4, data: {} },
  { tit: '诉讼费', type: 1, data: {} },
  { tit: '利息', type: 9, data: {} },
  { tit: '差旅费', type: 5, data: {} },
  { tit: '全部驳回', type: -1, data: {} }
]
export default {
  components: { lineChart },
  props: {
    // lineData: {
    //   type: Object,
    //   default() {
    //     return {
    //       load: false
    //     }
    //   }
    // },
    data: {
      type: Object,
      default() {
        return {
          fee_list: [],
          sum: {}
        }
      }
    }
  },
  data() {
    return {
      load: true
    }
  },
  watch: {
    data: {
      handler(newVal) {
        if (newVal) {
          this.load = false
        }
      },
    }
  },
  computed: {
    feeList() {
      if (this.data.fee_list.length > 0) {
        Fee_list.map(ele => {
          this.data.fee_list.map(element => {
            if (ele.type == element.type) {
              ele.data = element
            }
          })
        })
        return Fee_list
      }
    }
  }
}
</script>
<style lang="less" scoped>
.loadspin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.statistics {
  margin-top: 20px;

  .labelck {
    margin-bottom: 20px;

    b {
      font-size: 1rem;
      color: #0e2949;
      margin-right: 5px;
    }
  }
}

.moneyp {
  height: 260px;
  display: flex;
  align-items: center;
  position: relative;

  .hd {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    width: 200px;
    position: relative;
    margin-right: 10px;
    height: 260px;
    background: #f6f8fc;

    .li {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-left: 20px;
      justify-content: center;
      border-bottom: 1px solid #ddd;

      &:nth-last-child(1) {
        border: 0 none;
      }

      .tit {
        font-size: 0.875rem;
        color: rgba(14, 41, 73, 0.6);
        line-height: 20px;
      }

      .p {
        font-size: 1.125rem;
        font-weight: 500;
        color: #1e8bfe;
        line-height: 25px;
      }
    }
  }

  .rt {
    background: #f6f8fc;
    width: 300px;
    height: 100%;
    margin-left: 10px;
    padding: 20px 20px 10px;
  }

  .mid {
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;
    flex: 3;
    height: 260px;
    background: #f6f8fc;
    padding: 20px 0 0 20px;

    .li {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-bottom: 10px;

      .warp {
        width: 100%;
        display: flex;
      }

      &:nth-child(3n) {
        margin: 0;
      }

      .tp {
        width: 100%;
        display: flex;
        align-items: center;
        height: 18px;
        font-size: 1rem;

        white-space: nowrap;

        h4 {
          color: #0e2949;
          font-weight: bold;
          margin-bottom: 0;
          margin-right: 5px;
        }

        .span {
          display: flex;
          align-items: center;
          color: #0e2949;
          margin-right: 18px;

          &::before {
            display: block;
            content: "";
            width: 5px;
            height: 5px;
            background: #1e8bfe;
            border-radius: 50%;
            margin-right: 5px;
          }
        }
      }

      .p {
        font-size: 0.875rem;
        white-space: nowrap;
        line-height: 17px;
        font-weight: normal;
        color: #0e2949;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        margin-right: 20px;
        flex: 1;

        &::before {
          display: block;
          content: "";
          width: 5px;
          height: 5px;
          background: #1e8bfe;
          border-radius: 50%;
          margin-right: 5px;
        }
      }

      .mess {
        align-items: baseline;
        opacity: 0.33;

        &::before {
          background: #a8b2bf;
        }
      }
    }
  }
}
</style>